// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ix-0";
export var fileList = "_ix-2";
export var removeFileButton = "_ix-1";